import React, {  useState } from "react";
import { Footer } from "@components";
import { post } from "@utils/axios_api";
import { Input } from "@components/form";
import { AuthHook } from '@hooks';
const ApplyOnline = () => {

  const { auth } = AuthHook();
  const [loading, setLoading] = useState(false);
  
  const handleMoveOnlineLink = async (e) => {
    e.preventDefault();
    if(!auth.isAuthenticated) {
      alert('로그인이 필요합니다.');
      return;
    }
    try {
      setLoading(true);
      const { redirectUrl = "" } = await post("/online/forceLogin"); 

      if (!redirectUrl.trim()) {               
        alert("온라인 교육 URL을 받지 못했습니다. 잠시 후 다시 시도해 주세요.");
        return;
      }

      window.location.href = encodeURI(redirectUrl);                  
    } catch (err) {
      alert(err.message || "온라인 교육 이동 실패");
    } finally {
      setLoading(false);
    }

  };


  return (
    <main id="main" className="mainpage">
      <div>
        <div className="section main-contact">
          <div className="sub-tit-bg">
            <div className="container sub-h">
              <div className="sub-tit-01">
                <img src="/img/ico-home.png" alt="home" />
                온라인 교육
              </div>
            </div>
          </div>

          <div className="sub-container">
            <div className="sub-layout">
              <div className="sub-contact">
                <div><span style={{fontSize:"1.5rem", fontWeight:"bold"}}>온라인 교육 파트너 올인 에듀</span></div>
                  <div className="text-cent">
                    <button
                      type="button"
                      className="btn btn-blue mt30 btn-big"
                      onClick={handleMoveOnlineLink}
                      disabled={loading}
                    >
                       {loading ? <span className="spinner" /> : '온라인 교육 이동 하기'}
                    </button>
                  </div>

              </div>
            </div>
          </div>
          <div style={{marginBottom:'248px'}}></div>
          <Footer />
        </div>
      </div>
    </main>


  );
};

export default ApplyOnline;
